<template>
  <button class="column btn-clear place-card" v-on="$listeners" :class="{loading: isLoading}" >
    <transition name="fade-in">
      <div v-if="!isLoading" class="content">
        <div class="image-placeholder">
          <slot>
            <div class="mb-s placeImage">
              <img :src="activityImg" alt="" />
            </div>
          </slot>
        </div>
        <div class="details">
          <div class="name" v-html="formattedName"></div>
          <div class="t-copy sm mb-s">{{ address }}</div>
          <div class="rating-wrapper" v-if="isRatingShown">
            <StarRating class="star-rating" v-if="rating" :rating="+rating" read-only :star-size="12" :increment="0.1" />
          </div>
        </div>

        <div class="cost">
          <div class="price-wrapper">
            <div class="price">{{ price }}</div>
            <slot name="actions"> </slot>
          </div>
        </div>
      </div>
    </transition>
  </button>
</template>

<script>
import Vue from 'vue';
import {usePlaceCardLogic} from '@common/place-card-logic/place-card-logic';
import VueCompositionAPI from '@vue/composition-api';
Vue.use(VueCompositionAPI);

import StarRating from 'vue-star-rating';

export default {
  components: {
    StarRating,
  },
  props: {
    activity: Object,
    isLoading: {
      type: Boolean,
      default: false,
    },
    isRatingShown: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onSelectItem() {
      this.$emit('item-selected');
    },
    onShowDetails() {
      this.$emit('show-details');
    },
  },
  setup(props) {
    return usePlaceCardLogic(props);
  },
};
</script>

<style lang="postcss" scoped>
.place-card {
  position: relative;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  display: block;
  page-break-inside: avoid;
  /* min-height: 150px; */
}

.place-card + .place-card {
  border-top: 1px solid #e7e7e7;
}

.content {
  flex: 1;
  display: flex;
}

.image-placeholder {
  width: 60px;
  height: 60px;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  background-color: #f1f1f1;
  flex-shrink: 0;
}
.placeImage {
  & > img {
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
  }
}

.tags {
  margin: 0 -5px;
}

.tag {
  position: relative;
  border-radius: 4px;
  font-size: 13px;
  padding: 5px 10px 3px;
  display: inline-block;
  margin: 4px;
  text-transform: capitalize;
  border: 1px solid #f1f1f1;
  color: #a1a1a1;
}

.tag.withchecks {
  background-color: #f1f1f1;
  color: inherit;
}

.tag.withchecks::before {
  content: '';
  position: absolute;
  top: 3px;
  right: 3px;
  margin: -8px -8px 0 0;
  opacity: 1;
  transform: none;
  width: 12px;
  height: 12px;
  border-radius: 14px;
  background-color: #a3abb6;
  border: 2px solid #fff;
  background-image: url("data:image/svg+xml,%3Csvg width='6' height='5' viewBox='0 0 6 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.3215 0.617066C5.53299 0.794617 5.56051 1.11 5.38296 1.3215L2.86444 4.3215C2.76944 4.43466 2.62925 4.50001 2.48149 4.50001C2.33374 4.50001 2.19355 4.43466 2.09855 4.3215L0.617066 2.55679C0.439515 2.3453 0.467031 2.02991 0.678526 1.85236C0.890021 1.67481 1.20541 1.70233 1.38296 1.91382L2.48149 3.22237L4.61707 0.678526C4.79462 0.467031 5.11 0.439515 5.3215 0.617066Z' fill='white'/%3E%3C/svg%3E%0A");
  background-size: 7px;
  background-position: 1px 1px;
  background-repeat: no-repeat;
}

.cost {
  margin-top: 15px;
  font-size: 18px;
  line-height: 0.9em;
  display: flex;
  justify-content: space-between;
  flex: 1;
}

.cost-aligner {
  align-self: flex-end;
  display: flex;
  width: 100%;
}

.caption {
  font-size: 10px;
  color: #a3abb6;
}

.btn-clear {
  background: none;
  border: none;
  -webkit-appearance: none;
  text-align: left;
  cursor: pointer;
}

.rating-wrapper {
  position: relative;
  top: -20px;
  width: 0;
}

.price-wrapper {
  margin-left: auto;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 118.14%;
  /* or 28px */

  text-align: right;
  letter-spacing: -0.005em;

  color: #071d3b;

  display: flex;
  align-items: flex-start;
}

.price {
  padding-right: 10px;
  padding-top: 2px;
  /* border-right: 1px solid #f1f1f1; */
  margin-right: 10px;
  margin-top: 5px;
}

.details {
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.name {
  font-style: normal;
  font-size: 18px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: #071d3b;
}
</style>

<style>
.vue-star-rating-rating-text {
  font-size: 12px;
  color: #a3abb6;
  position: relative;
  top: -3px;
}
</style>

<style scoped>
.loading {
  position: relative;
  background-color: #e2e2e2;
  overflow: hidden;
  /* border-radius: 10px; */
}

.loading::after {
  display: block;
  content: '';
  position: absolute;
  top: 0;
  width: 25%;
  height: 100%;
  will-change: transform;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  animation: loading 1.5s infinite;
}

.star-rating {
  padding-top: 16px;
}

@keyframes loading {
  100% {
    transform: translateX(400%);
  }
}

.fade-in-out-leave-active {
  position: absolute;
  transition: opacity 0.2s ease-out;
}

.fade-in-out-leave-to {
  opacity: 0;
}

.fade-in-out-leave {
  opacity: 1;
}

.fade-in-out-enter-active {
  transition: opacity 0.5s ease-out;
}

.fade-in-out-enter-to {
  opacity: 1;
}

.fade-in-out-enter {
  opacity: 0;
}
</style>
